import { DataTableHeaderSort } from "@walmart-web/livingdesign-components"

export const ITEMS_PER_PAGE = 10
export const SORTING_DESCENDING: DataTableHeaderSort = "descending"
export const SORTING_ASCENDING: DataTableHeaderSort = "ascending"
export const NO_SORTING: DataTableHeaderSort = "none"
export const SORT_ASCENDING = 1
export const SORT_DESCENDING = -1
export const FIRST_PAGE = 0
export const EMPTY_STRING = ""
export const RETRIES = 2
